export const delay = (s: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, s * 1000));
